import React from 'react';
import { Button } from './Button';
import { AISparkleIcon } from './Icons';

interface AIRecommendationsButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

/**
 * AIRecommendationsButton - Centralized "Get AI Recommendations" button
 *
 * Features:
 * - Sparkle icon indicating AI-powered action
 * - Responsive text: "Get AI Recs" on mobile, "Get AI Recommendations" on desktop
 * - mobileTouch for 48px minimum touch target (WCAG accessibility)
 * - Matches AddManuallyButton for consistent UX
 *
 * Note: Status display is handled by the parent ActionButtonGroup component.
 * Use the `getAIButtonStatus()` helper (from `@/components/ui` barrel, or
 * directly from `./aiButtonStatus`) to compute status text.
 */
export const AIRecommendationsButton: React.FC<AIRecommendationsButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
}) => {
  return (
    <Button
      variant="primary"
      onClick={onClick}
      disabled={disabled || isLoading}
      mobileTouch
    >
      <AISparkleIcon className="w-6 h-6 mr-1.5 ml-0.5 -mt-1 flex-shrink-0 text-white" />
      <span className="sm:hidden">Get AI Recs</span>
      <span className="hidden sm:inline">Get AI Recommendations</span>
    </Button>
  );
};
